<template>
  <div class="nfHeader">
    <div class="base_panel_search flex justify_space">
      <div class="base_panel_search_label">筛选项 <slot name="searchName"></slot></div>
      <div class="base_panel_btn">
        <el-button v-if="overHeight" size="mini" type="text" @click="isOverHeight = !isOverHeight">
          {{ !isOverHeight ? '收起' : '更多筛选' }}
          <i :class="!isOverHeight ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" class="_445EBF" />
        </el-button>
        <el-button v-if="!search" class="header_radio" size="mini" type="primary" @click="onSearch">
          查询
        </el-button>
        <el-button v-if="!search && isreset" class="header_radio" size="mini" @click="initSearch"
          >重置
        </el-button>
        <el-button
          v-if="isExport.isShow"
          :disabled="isExport.disabled"
          class="header_radio"
          icon="el-icon-download"
          size="mini"
          type="primary"
          @click="exportList"
        >
          导出
        </el-button>
        <slot name="button"></slot>
      </div>
    </div>
    <div
      v-if="parameters && parameters.length > 0"
      ref="baseForm"
      :class="isOverHeight ? 'overHeight' : ''"
      class="base_form"
    >
      <el-form :inline="true" label-position="right" label-width="100px">
        <template v-for="(item, index) in parameters">
          <el-form-item :key="index" :label="item.label" class="base_form_item">
            <span slot="label" class="base_form_item_label">{{ item.label }}</span>
            <nf-select
              v-if="item.style === 'select'"
              :clearable="item.clearable"
              :filterable="item.filterable"
              :formData="item"
              :index="index"
              :multiple="item.multiple"
              :noMatchText="item.noMatchText"
              :placeholder="item.placeholder"
              :storeModelName="storeModelName"
              :value="item.value"
              class="base_form_select"
            />
            <nf-input
              v-if="item.style === 'input'"
              :clearable="item.clearable"
              :formData="item"
              :index="index"
              :placeholder="item.placeholder"
              :storeModelName="storeModelName"
              :value="item.value"
              class="base_form_input"
            />
            <nf-input
              v-if="item.style === 'input-multiple'"
              :clearable="item.clearable"
              :formData="item"
              :index="index"
              :placeholder="item.placeholder"
              :storeModelName="storeModelName"
              :value="item.value"
              class="base_form_input"
            />
            <nf-date-picker
              v-if="item.style === 'date-picker'"
              :clearable="item.clearable"
              :formData="item"
              :format="item.format"
              :index="index"
              :placeholder="item.placeholder"
              :size="item.size"
              :storeModelName="storeModelName"
              :type="item.type"
              :value="item.value"
              :value-format="item.valueFormat"
              class="base_form_date_picker"
            />
            <nf-casccader
              v-if="item.style === 'casccader'"
              :clearable="item.clearable"
              :formData="item"
              :index="index"
              :placeholder="item.placeholder"
              :size="item.size"
              :storeModelName="storeModelName"
              :type="item.type"
              :value="item.value"
              class="base_form_date_picker"
            />

            <nf-casccader1
              v-if="item.style === 'casccader1'"
              :clearable="item.clearable"
              :formData="item"
              :index="index"
              :placeholder="item.placeholder"
              :size="item.size"
              :storeModelName="storeModelName"
              :type="item.type"
              :value="item.value"
              class="base_form_date_picker"
            />
            <nf-autocomplete
              v-if="item.style === 'autocomplete'"
              :clearable="item.clearable"
              :formData="item"
              :index="index"
              :placeholder="item.placeholder"
              :size="item.size"
              :storeModelName="storeModelName"
              :type="item.type"
              :value="item.value"
              class="base_form_date_picker"
            />
            <nf-interval
              v-if="item.style === 'interval'"
              :clearable="item.clearable"
              :formData="item"
              :index="index"
              :placeholder="item.placeholder"
              :size="item.size"
              :storeModelName="storeModelName"
              :type="item.type"
              :value="item.value"
              class="base_form_date_picker"
            />
          </el-form-item>
        </template>
      </el-form>
    </div>
    <template v-if="isSpecialButton && isSpecialButton.length > 0">
      <div class="flex">
        <div v-for="(item, index) in isSpecialButton" :key="index" class="base_form base_form_1">
          <el-form :key="index" ref="form" label-width="85px" size="small">
            <el-form-item class="base_form_item">
              <span slot="label" class="base_form_item_label">{{ item.title }}</span>
              <div>
                <template v-for="item1 in item.selectList">
                  <el-button
                    :disabled="item.disabled ? item.disabled : false"
                    :key="item1.value"
                    :size="item.size || 'mini'"
                    :type="item1.isActive ? 'primary' : ''"
                    class="base_form_item_button"
                    @click="handleStatusChange(index, item1)"
                  >
                    {{ item1.label }}{{ item.disabled }}
                    <span v-if="item1.count">({{ item1.count }})</span>
                    <el-tooltip v-if="item1.tips" placement="bottom">
                      <span slot="content" class="nf-tooltip" v-html="item1.tips" />
                      <i class="iconfont font_13 iconyypt_zhushi" />
                    </el-tooltip>
                  </el-button>
                </template>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <slot name="isCheck"></slot>
      </div>
    </template>
  </div>
</template>

<script>
/*
 *    @params parameters 数组格式 筛选项
 *    input 输入框
 *       style input
 *       param 参数名
 *       value 参数值
 *       label 表单label
 *       placeholder 默认占位符
 *       clearable 是否开启清除
 *     select 下拉选择框
 *       style select
 *       param 参数名
 *       value 参数值
 *       label 表单label
 *       placeholder 默认占位符
 *       clearable 是否开启清除
 *       filterable  是否开启输入筛选
 *       path 定义在store的请求方法
 *       noMatchText 无匹配数据展示
 *
 *     date-picker 日期选择器
 *       style date-picker
 *       param 参数名
 *       value 参数值 []
 *       label 表单label
 *       placeholder 默认占位符
 *       clearable 是否开启清除
 *       format  展示时间格式
 *       valueFormat value值时间格式
 *       params 对应后端的参数名 []
 *
 * */

import NfSelect from '@/components/nf-select-list/components/nf-select';
import NfInput from '@/components/nf-select-list/components/nf-input';
import NfDatePicker from '@/components/nf-select-list/components/nf-date-picker';
import NfCasccader from '@/components/nf-select-list/components/nf-cascader';
import NfCasccader1 from '@/components/nf-select-list/components/nf-cascader1';
import NfAutocomplete from '@/components/nf-select-list/components/nf-autocomplete';
import NfInterval from '@/components/nf-select-list/components/nf-interval';
import { downloadFileAndBlob } from '@/utils/download';

export default {
  name: 'nf-header',
  components: {
    NfSelect,
    NfInput,
    NfDatePicker,
    NfCasccader,
    NfCasccader1,
    NfAutocomplete,
    NfInterval,
  },
  props: {
    // vuex Model 名称
    storeModelName: {
      type: String,
      required: true,
      default: '',
    },
    isreset: {
      default: true,
      type: Boolean,
    },
  },
  watch: {
    isOverHeight: {
      deep: true,
      handler(val) {
        this.heightChange(val);
      },
    },
  },
  data() {
    return {
      overHeight: false,
      isOverHeight: false,
    };
  },
  computed: {
    parameters() {
      return this.$store.state[this.storeModelName].parameters;
    },
    isSpecialButton() {
      return this.$store.state[this.storeModelName].isSpecialButton;
    },
    isSpecialTabs() {
      return this.$store.state[this.storeModelName].isSpecialTabs;
    },
    isExport() {
      return this.$store.state[this.storeModelName].isExport || false;
    },
    search() {
      return this.$store.state[this.storeModelName].search;
    },
  },
  methods: {
    onSearch() {
      this.$store.dispatch(`${this.storeModelName}/getList`);
      this.$emit('onSearch');
    },
    initSearch() {
      this.$store.commit(`${this.storeModelName}/initFilter`);
      this.$store.dispatch(`${this.storeModelName}/getList`);
      this.$emit('initSearch');
    },
    // 导出
    exportList() {
      const { method } = this.isExport;
      let { url } = this.isExport;
      const params = {
        ...this.$store.state[this.storeModelName].postParams,
      };
      this.parameters.forEach(item => {
        if (item.style !== 'date-picker' && item.value) {
          if (item.multiple && item.value === 'string') {
            params[item.param] = item.value.toString();
          } else {
            params[item.param] = item.value;
          }
        }
        if (item.style === 'date-picker' && item.value.length > 0) {
          params[item.params[0]] = `${item.value[0]} 00:00:00`;
          params[item.params[1]] = `${item.value[1]} 23:59:59`;
        }
      });
      this.isSpecialButton &&
        this.isSpecialButton.forEach(item => {
          if (item.value || item.value === 0) params[item.name] = item.value;
        });
      this.isSpecialTabs &&
        this.isSpecialTabs.selectList.forEach(item1 => {
          if (item1.isActive && item1.value !== 'all') {
            params[item.name] = item1.value;
          }
        });
      if (method === 'post') {
        downloadFileAndBlob({
          url,
          method,
          data: params,
        });
      } else {
        Object.keys(params).forEach(key => {
          url = this.addURLParam(url, key, params[key]);
        });
        window.open(url);
      }
    },
    addURLParam(url, name, value) {
      url += url.indexOf('?') === -1 ? '?' : '&'; //判断url中是否有'?'
      url += `${encodeURIComponent(name)}=${encodeURIComponent(value)}`; //拼接
      return url;
    },
    // 状态改变处理
    handleStatusChange(index, obj) {
      this.$store.commit(`${this.storeModelName}/updateSpecialStatusFromIndex`, {
        index,
        ...obj,
      });
      this.$emit('handleStatusChange', obj);
      this.onSearch();
    },
    heightChange(val) {
      this.$emit('heightChange', val);
    },
  },
  mounted() {
    if (this.parameters && this.parameters.length > 0) {
      this.isOverHeight = this.$refs['baseForm'].offsetHeight - 116 > 0;
      this.overHeight = this.$refs['baseForm'].offsetHeight - 116 > 0;
    }
  },
};
</script>

<style lang="scss" scoped>
.nfHeader {
  background-color: #fff;
  border-radius: 4px;

  .base_panel_header {
    display: none;
    padding: 15px;
    height: 48px;
    line-height: 16px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC, serif;
    font-weight: 600;
    color: #181818;
    border-bottom: 1px solid #edeeee;
  }

  .base_panel_search {
    display: none;
    padding: 8px 15px;
    height: 48px;
    line-height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC, serif;
    font-weight: 600;
    color: #181818;
    border-bottom: 1px solid #edeeee;

    .base_panel_search_label {
      font-size: 16px;
    }

    .base_panel_btn {
      line-height: 32px;

      i {
        font-size: 12px;
      }
    }
  }

  .base_form {
    padding: 15px 15px 5px;

    .base_form_item {
      min-height: 40px;
      padding-bottom: 5px;
      font-size: 12px !important;
      margin: 0;

      .base_form_item_label {
        text-align: right;
        font-size: 14px !important;
        line-height: 32px;
      }

      .base_form_item_button {
        margin-top: 4px;
      }
    }

    * {
      -webkit-text-size-adjust: none;
    }

    .base_form_select {
      width: 195px;
    }

    .base_form_input {
      width: 195px;
    }

    ::v-deep .el-input-group--append {
      margin-top: 4px;

      .el-input-group__append {
        width: 62px;
        padding: 0;
        text-align: center;
        background-color: #edeff9;
      }

      .el-input-group__append:hover {
        background-color: #445ebf;
        color: #ffffff;
      }
    }

    .base_form_date_picker {
      width: 195px;
    }

    .header_badge {
      height: 32px;
      margin-right: 10px;
      margin-top: -2px;
    }
  }

  .base_form_1 {
    padding-top: 0;
  }
}
</style>
